import { z } from 'zod';
import { templateIdSchema } from './templates.js';
/**
 * What the sender (a later slice) is handed: a recipient and rendered bytes.
 *
 * Strict, and with no attachment key of any name. PLAN §7.5 says links, not attachments;
 * an object carrying `attachments` is refused here, so no future adapter can be handed one.
 * The body is the RENDERED subject, HTML and text — never a template id plus a context
 * that would re-render differently after a copy edit.
 */
export const mailMessageSchema = z
    .object({
    to: z.string().email(),
    templateId: templateIdSchema.nullable(),
    subject: z.string().min(1),
    html: z.string().min(1),
    text: z.string().min(1),
})
    .strict();
//# sourceMappingURL=message.js.map